export default function findPosts(requestData, responseFunction, actionType, postsWrapper) {
	requestData.action = 'findPosts';

	(function ($) {
		$(document).ready(function ($) {
			$.ajax({
				url: adminAJAX.ajaxurl,
				method: 'POST',
				data: requestData,
				beforeSend: function () {
					// $('.posts-filter__loading-message').remove();

					switch (actionType) {
						case 'append':
							postsWrapper.append('<p class="posts-filter__loading-message">Cargando...</p>');
							break;
						case 'overwrite':
							postsWrapper.html('<p class="posts-filter__loading-message">Cargando...</p>');
							break;
						default:
							break;
					}
				},
				success: function (res) {
					responseFunction(res);
				},
				error: function (error) {
					console.error(error);
				}
			});
		});
	})(jQuery);
}
